import { Row, Col, Image } from 'react-bootstrap';
import { useInView } from 'react-intersection-observer';

export const SchoolWork = ({
    dates,
    title,
    subtitle,
    feature,
    paragraph,
    imagepath,
    imagelink,
    leftAligned,
    logoClassName = '',
}) => {
    const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });

    const containerClass = [
        'school-work',
        leftAligned ? 'school-work-left' : 'school-work-right',
        inView ? 'fade-in-container' : '',
    ].filter(Boolean).join(' ');

    return (
        <div className={containerClass} ref={ref}>
            {imagepath && (
                <a href={imagelink} target="_blank" rel="noopener noreferrer" title="" className="mobile-logo-badge">
                    <Image src={imagepath} alt="" fluid className={logoClassName} />
                </a>
            )}
            <Row>
                {imagepath && (
                    <Col
                        md={4}
                        className={leftAligned ? 'order-md-1' : 'order-md-2'}
                        style={leftAligned ? {} : { display: 'flex', justifyContent: 'flex-end' }}
                    >
                        <div className="image-wrapper">
                            <a href={imagelink} target="_blank" rel="noopener noreferrer" title="">
                                <Image src={imagepath} alt="" fluid className={`logo ${logoClassName}`.trim()} />
                            </a>
                        </div>
                    </Col>
                )}
                <Col md={imagepath ? 8 : 12} className={leftAligned ? 'order-md-2' : 'order-md-1'}>
                    <div>
                        <p className="dates">{dates}</p>
                        <p className="title">{title}</p>
                        <p className="subtitle">{subtitle}</p>
                        {feature && <p className="feature">{feature}</p>}
                        <p className="paragraph">{paragraph}</p>
                    </div>
                </Col>
            </Row>
        </div>
    );
};
